
















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import OutageNotificationBanner from "@/shared/components/OutageNotificationBanner.vue";
import Notifier from "@/shared/components/Notifier.vue";
import AdminHeader from "./shared/Header.vue";
import DatadogScript from "@/shared/components/DatadogScript.vue";
import { throttle } from "lodash";
import {
  AuthType,
} from "@/shared/types";
import { LoginRouteNames } from "@/shared/loginRoutes";
import { useUserStore } from "@/shared/store/user";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useThemeStore } from "@/shared/store/theme";
import router from "@/admin/routes";
import { useRootStore } from "@/shared/store/root";
import Flagging from "@/shared/flagging";

@Component({
  components: { AdminHeader, Notifier, DatadogScript, OutageNotificationBanner }
})
export default class App extends Vue {
  rootStore = useRootStore();
  featureFlagStore = useFeatureFlagStore();
  themeStore = useThemeStore();
  userStore = useUserStore();
  retryCount = 0;

  created () {
    this.rootStore.setupRoot();
    Flagging.initialize();
    this.registerActivity = throttle(this.registerActivity, 15000).bind(this);
    this.userStore.startAutologoutTimer();
    if (this.userStore.loggedIn) {
      this.featureFlagStore.setUserContext({ email: this.userStore.email });
    }
    this.setAuthTypeBaseOnFeatureFlag();
  }

  setAuthTypeBaseOnFeatureFlag () {
    if (!this.featureFlagStore.featureFlagsAvailable && this.retryCount < 20) {
      this.retryCount++;
      setTimeout(this.setAuthTypeBaseOnFeatureFlag, 500, this.featureFlagStore.featureFlagsAvailable);
    } else {
      if (this.featureFlagStore.flags.hsa4475allowRolePermissions) {
        this.userStore.setAuthType(AuthType.Okta);
        if (!this.userStore.loggedIn && this.$route.name !== LoginRouteNames.AdminOktaLogin) {
          this.$router.push({ name: LoginRouteNames.AdminOktaLogin });
        }
      } else {
        this.userStore.setAuthType(AuthType.Cognito);
        if (!this.userStore.loggedIn && this.$route.name !== LoginRouteNames.Login) {
          this.$router.push({ name: LoginRouteNames.Login });
        }
      }
    }
  }

  registerActivity () {
    this.userStore.activeUserPing();
  }

}
